import { AbstractControl } from '@angular/forms';
import { PowerSupplyService } from '@psnb/services';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class MACPlaceholderValidation {

  constructor(private powerSupplyServiceService: PowerSupplyService) {}

  static ValidateMac = () => {
    return (control: AbstractControl) => {
      const rex: RegExp = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
      if ((!rex.test(control.value) && control.value !== '') || control.value.length != 17) {
        return { validateMac: true }
      }
      return null;
    }
  }

  static ValidateEditMac = () => {
    return (control: AbstractControl) => {
      const rex: RegExp = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
      if ((!rex.test(control.value) && control.value !== '') || control.value.length != 17) {
        return { validateMac: true }
      }
      return null;
    }
  }

  static ValidateMac00 = () => {
    return (control: AbstractControl) => {
      if (control.value === '00:00:00:00:00:00' && control.value !== '') {
        return { validateMac00: true }
      }
      return null;
    }
  }

  ValidateExistingMac = () => {
    return (control: AbstractControl) => {
      if(control.value !== null) {
        if (control.value !== '' && control.value.length === 17) {
          this.powerSupplyServiceService.validateMacPlaceholder(control.value).subscribe(result => {
            if(result === true) {
              control.setErrors({validateExistingMac: true})
            } else return null;
          });
        }
      }
      return null;
    }
  }
}